import { EnumOption } from "./enum-option"

export const MatterReceiptShipMethod = {
  FedEx: 1,
  USPS: 2,
  UPS: 3,
  SameDayCourier: 4,
  Other: 5,
}

export const MatterReceiptShipMethodList: EnumOption[] = [
    { value: MatterReceiptShipMethod.FedEx, label: 'FedEx' },
    { value: MatterReceiptShipMethod.USPS, label: 'USPS' },
    { value: MatterReceiptShipMethod.UPS, label: 'UPS' },
    { value: MatterReceiptShipMethod.SameDayCourier, label: 'Same Day Courier' },
    { value: MatterReceiptShipMethod.Other, label: 'Other' },  
]
